import { themeComponents } from '@theme/theme-components';
import { themeCustomShadows } from '@theme/theme-custom-shadows';
import { themeMixins } from '@theme/theme-mixins';
import { themePalette } from '@theme/theme-palette';
import { themeTypography } from '@theme/theme-typography';

import { ThemeOptions } from '@mui/material/styles';
import { SystemMode } from '@mui/system/cssVars/useCurrentColorScheme';

export const themeOptions = (mode: SystemMode = 'light'): ThemeOptions => ({
  palette: themePalette(mode),
  typography: themeTypography(mode),
  components: themeComponents(mode),
  mixins: themeMixins,
  customShadows: themeCustomShadows,
  direction: 'ltr',
});
